/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered (register) {
      console.log('Service worker has been registered.')
      // Buscado por cambios cada 3 horas
      setInterval(() => {
        register.update()
      }, 1000 * 60 * 60 * 3)
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (register) {
      console.log('New content is available; please refresh.')
      document.dispatchEvent(
        new CustomEvent('updateSW', { detail: register })
      )
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
